import { ActionContext } from 'vuex';
import { AuthState, RootState, api } from '@/store';
import recaptcha from '@/plugins/recaptcha';

export default async (_: ActionContext<AuthState, RootState>, email: string) =>
  api.post({ url: '/restore', data: { email, recaptcha: await recaptcha('restore') } });
